/* Shared, delegated controls survive Shopify section reloads and page navigation. */
(() => {
  if (window.htlFinderReady) return;
  window.htlFinderReady = true;
  let step = 0, answers = {}, matches = [], catalogue = null, request = 0;
  const byId = id => document.getElementById(id);
  const entities = {'&amp;':'&','&lt;':'<','&gt;':'>','&quot;':'\"','&#39;':"'",'&#x27;':"'"};
  const config = () => { try { return JSON.parse(byId('htlFinderCopy')?.textContent || '{}', (key,value) => typeof value === 'string' ? value.replace(/&(?:amp|lt|gt|quot|#39|#x27);/g, entity => entities[entity]) : value); } catch (_) { return {}; } };
  const text = (key, fallback) => config()[key] || fallback;
  const escape = value => String(value ?? '').replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  const tags = product => (Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',')).map(tag => tag.trim().toLowerCase());
  const has = (product, tag) => tags(product).includes(tag);
  const dimension = (product, key) => Number(tags(product).find(tag => tag.startsWith(`finder:${key}:`))?.split(':').pop() || 0);
  const price = product => Math.min(...product.variants.map(variant => Number(variant.price)).filter(value => value > 0));
  const money = value => new Intl.NumberFormat('en-GB', {style:'currency',currency:'GBP',maximumFractionDigits:0}).format(value);
  const productURL = product => `/products/${encodeURIComponent(product.handle)}`;
  const budgetFits = product => { const value = price(product); return answers.budget === 'finder:budget:under5k' ? value < 5000 : answers.budget === 'finder:budget:5k-8k' ? value >= 5000 && value < 8000 : answers.budget === 'finder:budget:8kplus' ? value >= 8000 : true; };
  const powerFits = product => !answers.power || answers.power === 'any' || has(product, answers.power) || (answers.power !== 'finder:power:both' && has(product, 'finder:power:both'));
  function spaceFits(product) {
    const length = Number(answers.spaceLength), width = Number(answers.spaceWidth), access = Number(answers.accessWidth);
    const pl = dimension(product, 'length'), pw = dimension(product, 'width'), depth = dimension(product, 'depth');
    return (!length || !width || !pl || !pw || (pl <= length && pw <= width) || (pl <= width && pw <= length)) && (!access || !depth || depth <= access);
  }
  function checks(product) {
    return [has(product, answers.capacity), budgetFits(product), !answers.lounger || answers.lounger === 'any' || has(product, answers.lounger), powerFits(product)];
  }
  function activate(screen) {
    byId('htlQuizModal')?.querySelectorAll('.htl-quiz-screen').forEach(node => node.classList.toggle('is-active', node === screen));
    const body = byId('htlQuizModal')?.querySelector('.htl-quiz-body');
    if (body) body.scrollTop = 0;
    const heading = screen?.querySelector('h3');
    if (heading) { heading.tabIndex = -1; heading.focus({preventScroll:true}); }
  }
  function setModal(id, open) {
    const modal = byId(id);
    if (!modal) return;
    modal.classList.toggle('is-open', open);
    const anyOpen = document.querySelector('.htl-home-modal.is-open,.htl-lc-overlay.is-open');
    document.body.style.overflow = anyOpen ? 'hidden' : '';
    document.body.classList.toggle('htl-mobile-dialog-open', !!anyOpen);
  }
  window.htlShowStep = next => {
    step = Number(next);
    activate(document.querySelector(`#htlQuizModal [data-step="${step}"]`));
    if (byId('htlQuizProgress')) byId('htlQuizProgress').style.width = `${(step + 1) / 8 * 100}%`;
  };
  const openQuiz = () => {
    if (!byId('htlQuizModal')) { location.assign('/#finder'); return; }
    setModal('htlQuizModal', true); window.htlShowStep(0);
  };
  window.htlOpenQuiz = openQuiz;
  window.htlCloseQuiz = () => setModal('htlQuizModal', false);
  window.htlOpenShowroom = () => { window.htlCloseQuiz(); location.assign('/#our-showroom'); };
  window.htlCloseShowroom = () => setModal('htlShowroomModal', false);
  window.htlNextStep = () => {
    const options = document.querySelector(`#htlQuizModal [data-step="${step}"] .htl-quiz-options`);
    if (options && !answers[options.dataset.question]) { options.querySelector('button')?.focus(); return; }
    window.htlShowStep(step + 1);
  };
  window.htlPrevStep = () => window.htlShowStep(Math.max(0, step - 1));
  window.htlSpaceChoiceNext = () => {
    if (!answers.spaceMode) return;
    if (answers.spaceMode === 'skip') { answers.spaceLength = ''; answers.spaceWidth = ''; answers.accessWidth = ''; showMatches(); }
    else window.htlShowStep(6);
  };
  window.htlSkipSpaceMeasurements = () => { answers.spaceLength = ''; answers.spaceWidth = ''; window.htlShowStep(7); };
  window.htlSaveSpaceAndContinue = () => {
    const fields = [byId('htlSpaceLength'), byId('htlSpaceWidth')];
    if (fields.some(field => !field.reportValidity())) return;
    answers.spaceLength = fields[0].value; answers.spaceWidth = fields[1].value; window.htlShowStep(7);
  };
  window.htlSkipAccessMeasurements = () => { answers.accessWidth = ''; showMatches(); };
  window.htlSaveAccessAndContinue = () => {
    if (!byId('htlAccessWidth').reportValidity()) return;
    answers.accessWidth = byId('htlAccessWidth').value; showMatches();
  };
  window.htlShowLead = () => showMatches();
  window.htlShowClosestMatches = () => showMatches(true);
  window.htlRequestFinderAdvice = () => activate(byId('htlLeadScreen'));
  window.htlReturnToMatches = () => activate(byId('htlResultsScreen'));
  async function products() {
    if (catalogue) return catalogue;
    const controller = new AbortController(), timeout = setTimeout(() => controller.abort(), 15000);
    try {
      let all = [];
      for (let page = 1; page <= 10; page++) {
        const response = await fetch(`/products.json?limit=250&page=${page}`, {signal:controller.signal});
        if (!response.ok) throw new Error('Catalogue unavailable');
        const data = await response.json();
        if (!Array.isArray(data.products)) throw new Error('Invalid catalogue');
        all = all.concat(data.products);
        if (data.products.length < 250) break;
      }
      catalogue = all.filter(product => has(product, 'finder:brand:htl') && Number.isFinite(price(product)));
      if (!catalogue.length) { catalogue = null; throw new Error('Empty catalogue'); }
      return catalogue;
    } finally { clearTimeout(timeout); }
  }
  function card(product, closest) {
    const name = product.title.split(' - ')[0];
    const image = product.images?.[0]?.src || '';
    const results = checks(product), labels = ['capacity_match','budget_match','lounger_match','power_match'];
    const reasons = results.flatMap((passed,index) => passed ? `<li>${escape(text(labels[index], ['Your group size','Your budget','Your seating choice','Your power choice'][index]))}</li>` : []).join('');
    return `<article class="htl-product-card"><a class="htl-product-media" href="${productURL(product)}"><img src="${escape(image)}" alt="${escape(name)}" loading="lazy" width="420" height="420"></a><div class="htl-product-body"><div class="htl-product-badges"><span class="htl-product-badge">${escape(text(closest ? 'close_match' : 'matched', closest ? 'Close match' : 'Matches your choices'))}</span></div><h4 class="htl-product-title">${escape(name)}</h4><div class="htl-product-price">${money(price(product))}</div><p>${escape(text('reserve','Reserve for £99 or pay in full'))}</p><ul class="htl-match-reasons">${reasons}</ul>${!spaceFits(product) ? `<p>${escape(text('check_space','Check space and access with us before arranging delivery.'))}</p>` : ''}<div class="htl-product-actions"><a class="htl-product-btn htl-product-btn--gold" href="${productURL(product)}" data-htl-home-action="finder-product">${escape(text('view','View details & reserve'))}</a></div></div></article>`;
  }
  async function showMatches(closest = false) {
    const token = ++request, grid = byId('htlResultsGrid'), status = byId('htlResultsText');
    if (!grid || !status) return;
    activate(byId('htlResultsScreen'));
    byId('htlQuizProgress').style.width = '100%';
    status.textContent = text('loading', 'Finding your hot tubs…'); status.setAttribute('role', 'status');
    grid.setAttribute('aria-busy','true'); grid.innerHTML = '';
    ['htlMoreMatchesWrap','htlFastInstallBox','htlAccessAdviceBox'].forEach(id => { if(byId(id)) byId(id).innerHTML = ''; });
    try {
      const all = await products();
      if (token !== request) return;
      const ranked = all.map(product => ({product, score:checks(product).filter(Boolean).length}));
      matches = ranked.filter(({product,score}) => (closest ? score > 0 : score === 4) && (answers.spaceMode !== 'strict' || spaceFits(product)))
        .sort((a,b) => b.score - a.score || price(a.product) - price(b.product)).map(item => item.product);
      status.textContent = matches.length ? text(closest ? 'close_results' : 'results', closest ? 'These are the closest options. Check the details against your preferences.' : 'Your matches, ordered by price. Open a model to compare colours, specifications and extras.') : text('empty', 'No exact match for those choices. Try nearby options or change your answers.');
      window.htlFinderTopMatch = () => matches[0]?.title || '';
      grid.innerHTML = matches.map(product => card(product, closest)).join('');
      if (!matches.length) grid.innerHTML = `<div class="htl-finder-empty"><button type="button" class="htl-quiz-btn htl-quiz-btn--gold" data-htl-finder-action="htlShowClosestMatches">${escape(text('closest','Show closest matches'))}</button><a href="/collections/hot-tubs-for-sale-in-liverpool" class="htl-quiz-btn">${escape(text('browse','Browse all hot tubs'))}</a></div>`;
      document.dispatchEvent(new CustomEvent('htl:finder-results', {detail:{count:matches.length,type:'hot_tub'}}));
    } catch (_) {
      if (token !== request) return;
      status.textContent = text('error', 'The range could not load. Please try again or browse all hot tubs.');
      grid.innerHTML = `<button class="htl-quiz-btn htl-quiz-btn--primary" data-htl-finder-action="htlShowLead">${escape(text('retry','Try again'))}</button><a class="htl-quiz-btn" href="/collections/hot-tubs-for-sale-in-liverpool">${escape(text('browse','Browse all hot tubs'))}</a>`;
    } finally { if (token === request) grid.removeAttribute('aria-busy'); }
  }
  const actions = new Set(['htlCloseQuiz','htlCloseShowroom','htlNextStep','htlPrevStep','htlSpaceChoiceNext','htlSkipSpaceMeasurements','htlSaveSpaceAndContinue','htlSkipAccessMeasurements','htlSaveAccessAndContinue','htlOpenShowroom','htlShowStep','htlShowClosestMatches','htlRequestFinderAdvice','htlReturnToMatches','htlShowLead']);
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-htl-open-finder]');
    if (trigger) {
      event.preventDefault();
      openQuiz();
      if (trigger.dataset.htlFinderCapacity) {
        const option = [...document.querySelectorAll('#htlQuizModal [data-question="capacity"] .htl-quiz-option')].find(node => node.dataset.value === trigger.dataset.htlFinderCapacity);
        if (option) { option.click(); window.htlNextStep(); }
      }
      return;
    }
    const option = event.target.closest('#htlQuizModal .htl-quiz-option');
    if (option) {
      const group = option.closest('.htl-quiz-options');
      group.querySelectorAll('.htl-quiz-option').forEach(node => { node.classList.toggle('is-selected', node === option); node.setAttribute('aria-pressed',String(node === option)); });
      answers[group.dataset.question] = option.dataset.value;
      const next = option.closest('.htl-quiz-screen')?.querySelector('.htl-quiz-nav .htl-quiz-btn--primary');
      if (next) next.disabled = false;
    }
    const button = event.target.closest('[data-htl-finder-action]');
    if (button && actions.has(button.dataset.htlFinderAction)) { event.preventDefault(); window[button.dataset.htlFinderAction](button.dataset.htlFinderStep); }
    if (event.target.id === 'htlQuizModal') window.htlCloseQuiz();
    if (event.target.id === 'htlShowroomModal') window.htlCloseShowroom();
    if (event.target.closest('#htlShareResultsBtn')) {
      const summary = matches.map(product => `${product.title} — ${money(price(product))}\n${location.origin}${productURL(product)}`).join('\n\n');
      if (navigator.share) navigator.share({title:'My hot tub shortlist',text:summary}).catch(() => {});
      else window.open(`https://wa.me/?text=${encodeURIComponent(summary)}`, '_blank', 'noopener');
    }
  }, true);
  document.addEventListener('submit', event => {
    if (event.target.id !== 'htlLeadForm') return;
    event.preventDefault();
    if (typeof window.htlSubmitFinderLead === 'function') window.htlSubmitFinderLead(event.target, answers, () => activate(byId('htlResultsScreen')));
  });

  if (location.hash === '#finder') window.htlOpenQuiz();
})();
